import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import OutlinedButton from 'components/atoms/OutlinedButton';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  selectAllBtn: {
    marginRight: 5,
  },
  btnColorAllCheck: {
    color: '#088',
  },
  btnColorCancel: {
    color: '#880',
  },
}));

const AllButtonBox = (props) => {
  const { tDepth, setSelectedSeqs, selectedSeqs } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  /**
   * 수정 클릭
   * @param {string} name
   * @param {*} value
   */
  const handleOnToggleClick = (checked) => (e) => {
    let newSelectedSeqs = [...selectedSeqs];
    if (checked) {
      for (let i = 0; i < tDepth.length; i++) {
        if (newSelectedSeqs.indexOf(tDepth[i].CTGR_SEQ) === -1) {
          newSelectedSeqs.push(tDepth[i].CTGR_SEQ);
        }
      }
    } else {
      for (let i = 0; i < tDepth.length; i++) {
        let idx = newSelectedSeqs.indexOf(tDepth[i].CTGR_SEQ);
        if (idx > -1) {
          newSelectedSeqs.splice(idx, 1);
        }
      }
    }
    setSelectedSeqs(newSelectedSeqs);
  };

  return (
    <>
      <OutlinedButton
        index={0}
        className={clsx(classes.selectAllBtn, classes.btnColorAllCheck)}
        onClick={handleOnToggleClick(true)}
      >
        {t('전체선택')}
      </OutlinedButton>
      <OutlinedButton
        index={1}
        className={clsx(classes.btnColorCancel)}
        onClick={handleOnToggleClick(false)}
      >
        {t('전체해제')}
      </OutlinedButton>
    </>
  );
};

export default AllButtonBox;
